"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapInPipesAndLowercase = exports.getWordCount = exports.cleanAndLowercase = exports.cleanAndCapitalize = exports.wrapInPipesAndCapitalize = void 0;
/**
 *
 * @param sentences comma separated string (ex. 'john doe, james bond')
 * @returns piped separated string (ex. '|John Doe|James Bond|')
 */
var wrapInPipesAndCapitalize = function (sentences) {
    if (sentences === '') {
        return sentences;
    }
    else {
        var capitalizedSentences = sentences
            .split(',')
            .map(function (sentence) {
            return sentence
                .trim()
                .split(' ')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' ');
        })
            .join('|');
        return "|".concat(capitalizedSentences, "|").replace(/\|+/g, '|');
    }
};
exports.wrapInPipesAndCapitalize = wrapInPipesAndCapitalize;
/**
 *
 * @param sentence String in any format (ex. 'Hello   world  example')
 * @returns String without extra white spaces and capiralizes all words(ex. 'Hello World Example')
 */
var cleanAndCapitalize = function (sentence) {
    // Remove extra spaces
    sentence = sentence.trim().replace(/\s+/g, ' ');
    // Capitalize first letter of each word
    sentence = sentence.replace(/^(.)|\s(.)/g, function (match) {
        return match.toUpperCase();
    });
    return sentence;
};
exports.cleanAndCapitalize = cleanAndCapitalize;
/**
 *
 * @param sentence String in any format (ex. 'Hello   WoRLd  ExaMple')
 * @returns String without extra white spaces and lower cases all words(ex. 'hello world example')
 */
var cleanAndLowercase = function (sentence) {
    sentence = sentence === null || sentence === void 0 ? void 0 : sentence.replace(/\s+/g, ' ').trim();
    return sentence === null || sentence === void 0 ? void 0 : sentence.toLocaleLowerCase();
};
exports.cleanAndLowercase = cleanAndLowercase;
/**
 *
 * @param text String content
 * @param isCountHtmlTags flag whether html tags text (in essence "markup") should be included in total count
 * @returns Number of words
 */
var getWordCount = function (text, isCountHtmlTags) {
    if (isCountHtmlTags === void 0) { isCountHtmlTags = false; }
    // account for empty string
    if (!text.trim()) {
        return 0;
    }
    if (!isCountHtmlTags) {
        // Remove HTML tags using a regular expression
        // Split the text into words using whitespace as the delimiter
        return text
            .replace(/<[^>]+>/g, '')
            .trim()
            .split(/\s+/).length;
    }
    else {
        return text.split(' ').filter(function (s) { return !!s; }).length;
    }
};
exports.getWordCount = getWordCount;
/**
 *
 * @param sentences comma separated string (ex. 'fo-123-345, fo-000-111')
 * @returns piped separated string (ex. '|fo-123-456|fo-000-111|')
 */
var wrapInPipesAndLowercase = function (sentences) {
    var trimmedSentences = sentences === null || sentences === void 0 ? void 0 : sentences.trim();
    if (sentences === '') {
        return '';
    }
    else {
        var lowercasedSentences = trimmedSentences
            .split(',')
            .map(function (sentence) { return sentence.trim().toLocaleLowerCase(); })
            .filter(function (sentence) { return sentence.trim().length > 0; })
            .join('|');
        return lowercasedSentences ? "|".concat(lowercasedSentences, "|") : '';
    }
};
exports.wrapInPipesAndLowercase = wrapInPipesAndLowercase;
//# sourceMappingURL=stringFormatters.js.map